export const addNormalizerToSagaFunction = (
  generatorFunction,
  normalizeHttpErrors,
) => {
  return function* newFunction(args) {
    yield generatorFunction({ ...args, normalizeHttpErrors });
  };
};

export const addParamsToSaga = (generatorFunction, paramsAsObj) => {
  return function* newFunction(args) {
    yield generatorFunction({ ...args, ...paramsAsObj });
  };
};
